<template>
    <div class="container">
        <div
            class="item"
            v-for="(item,index) in newData"
            :key="index"
        >
            <p class="name">{{item.name || ''}}</p>
            <div class="content" v-html="item.content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "remark-detail",
        props: {
            data: [Object, Array]
        },
        computed: {
            newData(){
                let data = this.data
                try {
                    if(!Array.isArray(data)){
                        data = [data]
                    }
                }catch (e) {
                    console.log('err', e)
                }
                return data
            }
        }
    }
</script>

<style lang="scss" scoped>
.item{
    box-shadow:0px 0px 2px 0px rgba(0, 0, 0, 1);
    border-radius:8px;
    padding: 16px;
    position: relative;

    .name{
        font-size: 14px;
        position: absolute;
        top: -10px;
        background-color: white;
        padding: 0px 6px;
    }
}
.item:nth-child(n+2){
    margin-top: 16px;
}
</style>
